<script setup>
const { $cdn } = useNuxtApp()

const props = defineProps({
    country: String,
    language: Boolean,
});

const icon = computed(() => {
    if (!props.country) {
        return;
    }
    const countryCode = props.country.toLowerCase();

    return props.language && countryCode === 'en' ? 'gb' : countryCode;
});

</script>

<template>
    <img v-if="icon" class="p-0 me-1" :class="`fi`" :alt="icon" :src="$cdn(`/img/flags/${icon}.webp`)" loading="lazy"/>
</template>


